import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "./VangalProductSlider.css";

// Import default images
import defaultImg1 from "../Assets/Vangal Butter.png";
import defaultImg2 from "../Assets/Vangal Ghee.png";
import defaultImg3 from "../Assets/Vangal Fresh Paneer.png";
import defaultImg4 from "../Assets/Vangal Malai Paneer.png";

const VangalProductSlider = () => {
  const [products, setProducts] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  // Desktop default images array
  const desktopDefaults = [defaultImg1, defaultImg2, defaultImg3, defaultImg4];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          "https://vangal-backend.onrender.com/api/products"
        );
        setProducts(
          res.data.map((p) => ({
            id: p.id,
            image: p.img,
            title: p.title,
          }))
        );
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 480);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const settings = {
    dots: !isMobile,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    swipeToSlide: true,
    centerMode: isMobile,
    centerPadding: isMobile ? "15%" : "0px",
  };

  // Decide what to display: backend products or defaults
  const slidesToShow = isMobile
    ? [defaultImg1] // mobile: single default
    : products.length > 0
    ? products.map((p) => p.image) // desktop: backend images
    : desktopDefaults; // desktop default fallback

  return (
    <section className="vangalSliderSection anim anim-bottom">
      <h2 className="vangalSliderTitle">Tradition You Can Taste</h2>

      <Slider {...settings} className="vangalProductSlider">
        {slidesToShow.map((imgSrc, index) => (
          <div key={index} className="vangalSlideItem">
            <div className="vangalProductCard">
              <img
                src={imgSrc}
                alt={`Product ${index + 1}`}
                className="vangalProductImg"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImg1; // fallback image
                }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default VangalProductSlider;
